<div class="layout-footer">
  <div class="mr-2">
    <img alt="logo" class="mr-2" height="20" src="../../../../assets/img/hello-sitter-logo.png">
  </div>
  <div>
    Version:
    <span class="font-medium ml-2 mr-2">November 2025</span>
  </div>
  <div>
    Status:
    <span class="font-medium ml-2 mr-2">{{ ENVIRONMENT_NAME }}</span>
  </div>
</div>
